const service = function(
	$http,
	$timeout,
	_,
	api,
	$q,
	$rootScope,
) {
	"ngInject";

	this.list = [];

	this.get = () => $http.get(api+'/v1/affiliate').then(res => {
		this.list = res.data;
		$rootScope.$broadcast('affiliate:list', this.list);
		return $q.resolve();
	})

	this.push = (data) => $http.post(api+'/v1/customer/affiliate', data);
};

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/affiliate.service.js